const constants = {
  actions: {
    CLEAR_STATE: 'EDR_DOCUMENTS_CLEAR_STATE_ACTION',

    STORE_LAND_REGISTRY_PART: 'EDR_DOCUMENTS_STORE_PART_ACTION',
    STORE_LAND_REGISTRY_PART_ERROR: 'EDR_DOCUMENTS_STORE_PART_ERROR',

    STORE_RIGHT: 'EDR_DOCUMENTS_STORE_RIGHT_ACTION',
    STORE_RIGHT_ERROR: 'EDR_DOCUMENTS_STORE_RIGHT_ERROR',

    SET_LOADING_STATUS: 'EDR_DOCUMENTS_SET_LOADING_STATUS',
    LAND_REGISTRY_LOADING_COMPLETE: 'LAND_REGISTRY_LOADING_COMPLETE',

    LAND_REGISTRY_TAG_LOADING: 'LAND_REGISTRY_TAG_LOADING',
    LAND_REGISTRY_TAG_LOADING_COMPLETE: 'LAND_REGISTRY_TAG_LOADING_COMPLETE',

    PURCHASE_PANTEBOK: 'LAND_REGISTRY_PURCHASE_PANTEBOK_ACTION',
    PURCHASED_PANTEBOK: 'LAND_REGISTRY_PURCHASED_PANTEBOK_ACTION',
    PURCHASE_PANTEBOK_FAILED: 'LAND_REGISTRY_PURCHASE_PANTEBOK_FAILED_ACTION',
    SET_ORDER_REFERENCE: 'LAND_REGISTRY_SET_ORDER_REFERENCE_ACTION'
  },
  events: {
    CADASTRE_CHANGED: 'EDR_DOCUMENTS_CADASTRE_CHANGED_EVENT',
    LAND_REGISTRY_LOADING_COMPLETE: 'LAND_REGISTRY_LOADING_COMPLETE',
    PURCHASE_PANTEBOK: 'LAND_REGISTRY_PURCHASE_PANTEBOK_EVENT',
    PURCHASED_PANTEBOK: 'LAND_REGISTRY_PURCHASED_PANTEBOK_EVENT',
    PURCHASE_PANTEBOK_FAILED: 'LAND_REGISTRY_PURCHASE_PANTEBOK_FAILED_EVENT',
    SET_ORDER_REFERENCE: 'LAND_REGISTRY_SET_ORDER_REFERENCE_EVENT'
  },
  constants: {
    CADASTRE: 'EDR_DOCUMENTS_CADASTRE'
  },
  states: {
    ACTIVE: 'active',
    HISTORICAL: 'historical',
    ACTIVE_AND_HISTORICAL: 'active_and_historical'
  },
  types: {
    ENCUMBRANCES: 'ENCUMBRANCES',
    EASEMENTS: 'EASEMENTS',
    TITLES: 'TITLES',
    LANDDATA: 'LANDDATA',
    MONETARY_ENCUMBRANCES: 'MONETARY_ENCUMBRANCES',
    PRIVILEGES: 'PRIVILEGES',
    RIGHT: 'RIGHT'
  },
  tags: {
    AMBITA_LAND_REGISTRY: 'ambita-landregistry'
  }
};

export = constants;
